<template>
  <div class="overlay">
    <div class="overlay-content">
      <a href="#" @click="back" class="overlay-close">✕</a>
      <div class="overlay-inner">
        <h2>Future Energy System</h2>

        <p>To bring <span class="versa">INNOVATION</span> to life it is necessary to imagine a different future for our energy system. By
          scrutinizing the current system one can imagine how a <span class="versa">FUTURE ENERGY SYSTEM</span> may look:</p>

        <p>Imagine it is 2035 and <span class="versa">RENEWABLE ENERGY</span> generation has surpassed 90% of overall electricity generation. This
          means the system is running without hardly any <span class="versa">FUEL</span>. Almost no coal, gas or other fuels are needed anymore
          which means in correlation that the operational costs of the energy system decrease massively. They now
          mainly consist of maintaining the system and repowering old or broken assets.
          The power generation happens almost everywhere through decentralized photovoltaic and wind power plants.</p>

        <p>If a region suffers from missing wind or sun, the energy can be routed in large <span class="versa">CAPACITIES</span> from one region to
          another by utilizing the newly-built high voltage lines. They have been built according to the network
          development plan of the Bundesnetzagentur, conceived in 2015. The new lines have been financed by fees on
          each consumed kWh over a period of almost 20 years.
          The need to automatically balance supply and demand for electricity made the energy system the ultimate
          application case for the <span class="versa">Digitalization</span> wave of the late 2010`s. As a result, the whole electricity industry
          has been successfully digitalized and works almost autonomously.</p>

        <p>Such a system has, after all, one large consequence: Once in place, its operational <span class="versa">COST</span>s are very <span class="versa">LOW</span>. This
          allows us to draw comparisons with the telecommunication network. Once sufficient network capacity has been
          installed by the introduction of fibers, flatrates have been born.</p>

        <p>Does that mean, we will at some point have an energy <span class="versa">FLATRATE</span>? Yes, certainly we think so. A flatrate paid by
          the maximum line capacity similar to today`s internet connections.
          And this raises a number of open question:</p>
        <ul>
          <li>What kind of regulation is needed for such a system?</li>
          <li>What kind of market design is needed?</li>
          <li>What kind of communication technology is needed to drive the <span class="versa">DIGITALISATION</span>?</li>
          <li>Who are the market actors and what does the value chain look like?</li>
        </ul>
        <p>We imagine such a future and attempt to answer these questions already today. Has this awoken your interest?
          If so, then please feel free to get in touch with us to work on the Energy System of the Future: <span class="versa">RELIABLE.
            AFFORDABLE. SUSTAINABLE</span>. 
        </p>
        <div class="footnote">
          <ul>Further readings:
            <li>(1) <a href="//www.energiewendebeschleunigen.de/megatrends/" target="_blank">WWF & Lichtblick – Megatrends der globalen
              Energiewende {2015} </a></li>
            <li>(2) <a
              href="//www.nytimes.com/2014/04/18/opinion/krugman-salvation-gets-cheap.html?ref=paulkrugman&_r=1" target="_blank">Paul
              Krugmann – Salvation Gets Cheap {2014}</a></li>
            <li>(3) <a
              href="//energy.gov/sites/prod/files/2013/09/f2/Revolution%20Now%20--%20The%20Future%20Arrives%20for%20Four%20Clean%20Energy%20Technologies.pdf" target="_blank">U.S.
              Department of Energy – Revolution Now {2013}</a></li>
            <li>(4) <a href="//www.thezeromarginalcostsociety.com" target="_blank">Jeremy Rifkin – The Zero Marginal Cost Society
              {2014}</a></li>
            <li>(5) <a href="http://www.netzausbau.de/EN/home/en.html" target="_blank">Creating Future-Proof Network – Bundesnetzagentur
              {2015}</a></li>
          </ul>
        </div>
        <p class="end"></p>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default {
    methods: {
      back () {
        window.history.go(-1)
      }},
    data: function () {
      return {
        title: 'Future Energy System'
      }
    },
    // Usage with context the component
    head: {
      // To use "this" in the component, it is necessary to return the object through a function
      title: function () {
        return {
          inner: this.title
        }
      },
      meta: [
        { name: 'description', content: 'My description', id: 'desc' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// Future.vue?3211c9ff